var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
import { inject } from "tsyringe";
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { ManualCrossSellingListProvider, NullCrossSellingListProvider, OnlineOrderingSettingsToken, SequentialCrossSellingListProvider, } from "../ordering";
import { MenuConsumer } from "../config";
import { AutomaticCrossSellingListProviderFactory } from "./AutomaticCrossSellingListProviderFactory";
import { CrossSellingListParser } from "../parsing";
function menuConsumerToCrossSellingConsumer(menuConsumer) {
    switch (menuConsumer) {
        case "Site":
            return "Site";
        case "QrWaiter":
            return "QrWaiter";
        case "VoiceOrder":
            // Cross-selling not yet implemented for voice orders.
            // Fallback to Site rules for now.
            return "Site";
    }
}
let CrossSellingListProviderFactory = class CrossSellingListProviderFactory {
    constructor(menuConsumer, onlineOrderingSettings, crossSellingListParser, automaticCrossSellingListProviderFactory) {
        this.onlineOrderingSettings = onlineOrderingSettings;
        this.crossSellingListParser = crossSellingListParser;
        this.automaticCrossSellingListProviderFactory = automaticCrossSellingListProviderFactory;
        this.crossSellingConsumer =
            menuConsumerToCrossSellingConsumer(menuConsumer);
        makeImmutable(this);
    }
    create(params) {
        const crossSellingListRepository = this.crossSellingListParser.parse(params.menuCatalogue);
        const { manualCrossSelling, automaticCrossSelling } = this.onlineOrderingSettings;
        const manual = manualCrossSelling.enabled &&
            manualCrossSelling.visibleIn.includes(this.crossSellingConsumer) &&
            crossSellingListRepository.isAnyCrossSellingListUsed
            ? new ManualCrossSellingListProvider(crossSellingListRepository)
            : null;
        const automatic = automaticCrossSelling.enabled &&
            automaticCrossSelling.visibleIn.includes(this.crossSellingConsumer)
            ? this.automaticCrossSellingListProviderFactory.create({
                weights: params.automaticWeights,
                menuCatalogue: params.menuCatalogue,
            })
            : null;
        if (manual !== null && automatic !== null) {
            console.log("Using sequential cross-selling list provider");
            return new SequentialCrossSellingListProvider([manual, automatic]);
        }
        if (manual !== null) {
            console.log("Using manual cross-selling list provider");
            return manual;
        }
        if (automatic !== null) {
            console.log("Using automatic cross-selling list provider");
            return automatic;
        }
        console.log("Cross-selling is disabled");
        return new NullCrossSellingListProvider();
    }
};
CrossSellingListProviderFactory = __decorate([
    perRestaurant(),
    __param(0, inject(MenuConsumer)),
    __param(1, inject(OnlineOrderingSettingsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof MenuConsumer !== "undefined" && MenuConsumer) === "function" ? _a : Object, Object, typeof (_b = typeof CrossSellingListParser !== "undefined" && CrossSellingListParser) === "function" ? _b : Object, typeof (_c = typeof AutomaticCrossSellingListProviderFactory !== "undefined" && AutomaticCrossSellingListProviderFactory) === "function" ? _c : Object])
], CrossSellingListProviderFactory);
export { CrossSellingListProviderFactory };
